import { Button } from '@mui/material';
import styled from 'styled-components';

import DotsIcon from 'assets/v2/DotsIcon';
import { COLORS } from 'theme';

export const StyledDotsIcon = styled(DotsIcon)`
  && {
    font-size: ${({ theme }) => theme.spacing.m1};
  }
`;

export const StyledButton = styled(Button)`
  &&& {
    min-height: unset;
    padding: 0;

    height: ${({ theme }) => theme.spacing.m4};
    width: ${({ theme }) => theme.spacing.m4};

    ${({ $isActive }) => $isActive && `background-color: ${COLORS.black08};`}
  }
`;
